import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// ── Sentry error monitoring ───────────────────────────────────────────────────
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN || "https://7a0e7735d2f2fa43f4c81053f94d4c88@o4511360923074560.ingest.us.sentry.io/4511360931463168",
  environment: process.env.NODE_ENV || 'production',
  tracesSampleRate: 0.1,
  ignoreErrors: [
    'ResizeObserver loop limit exceeded',
    'Non-Error promise rejection captured',
    'ChunkLoadError',
    /Loading chunk \d+ failed/,
  ],
  beforeSend(event) {
    if (event.breadcrumbs) {
      event.breadcrumbs.values = (event.breadcrumbs.values || []).map(b => ({
        ...b,
        message: b.message?.replace(/[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g, '[email]'),
      }));
    }
    return event;
  },
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
